import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CommonUiComponentsSpinnerComponent } from '@cdw-ae/common-ui-components-spinner';
import { CdwFileUploadComponent } from './file-upload/file-upload.component';

@NgModule({
  imports: [
    CommonModule,
    CdwButtonModule,
    MatIconModule,
    CommonUiComponentsSpinnerComponent,
  ],
  declarations: [CdwFileUploadComponent],
  exports: [CdwFileUploadComponent],
})
export class CdwFileUploadModule {}
